var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tabs',[_c('b-tab',{attrs:{"active":"","title":"Nomenclatura"}},[_c('nomenclatures-tab')],1),_c('b-tab',{attrs:{"title":"Modelos"}},[_c('models-tab')],1),_c('b-tab',{attrs:{"title":"Segmentos"}},[_c('segments-tab')],1),_c('b-tab',{attrs:{"title":"Marcas"}},[_c('brands-tab')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }